var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c(
          "div",
          {
            staticClass: "page-header-top-container",
            staticStyle: { width: "100% !important" }
          },
          [
            _c("div", { staticClass: "page-name" }, [
              _vm._v(_vm._s(_vm.page_header))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary waves-effect pull-right",
                attrs: { type: "submit" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.returnOnListing()
                  }
                }
              },
              [_vm._v("Back")]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "forms-container" }, [
            _c(
              "div",
              { staticClass: "row no-margin" },
              [
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fields.name,
                          expression: "fields.name"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.fields.name },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.fields, "name", $event.target.value)
                          },
                          function($event) {
                            _vm.name_error_msg = ""
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "help is-danger" }, [
                      _vm._v(_vm._s(_vm.name_error_msg))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fields.branch,
                          expression: "fields.branch"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.fields.branch },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.fields, "branch", $event.target.value)
                          },
                          function($event) {
                            _vm.branch_error_msg = ""
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "help is-danger" }, [
                      _vm._v(_vm._s(_vm.branch_error_msg))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fields.address,
                          expression: "fields.address"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: _vm.fields.address },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.fields, "address", $event.target.value)
                          },
                          function($event) {
                            _vm.addressError = ""
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "help is-danger" }, [
                      _vm._v(_vm._s(_vm.addressError))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm.isNonVVGDealer == "NO"
                  ? [
                      _c("div", { staticClass: "col-6 forms-block" }, [
                        _c("div", { staticClass: "form-label" }, [
                          _vm._v(
                            "Excede Location :\n                                    "
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.fields.isExcedeLocation,
                                expression: "fields.isExcedeLocation"
                              }
                            ],
                            staticClass: "ml-2",
                            attrs: { id: "isExcedeLocation", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.fields.isExcedeLocation
                              )
                                ? _vm._i(_vm.fields.isExcedeLocation, null) > -1
                                : _vm.fields.isExcedeLocation
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.fields.isExcedeLocation,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.fields,
                                        "isExcedeLocation",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.fields,
                                        "isExcedeLocation",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.fields, "isExcedeLocation", $$c)
                                }
                              }
                            }
                          })
                        ])
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fields.shipTo,
                          expression: "fields.shipTo"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", maxlength: "190" },
                      domProps: { value: _vm.fields.shipTo },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.fields, "shipTo", $event.target.value)
                          },
                          function($event) {
                            _vm.ship_to_error_msg = ""
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "help is-danger" }, [
                      _vm._v(_vm._s(_vm.ship_to_error_msg))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-9 paddingleft0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fields.billTo,
                          expression: "fields.billTo"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", maxlength: "190" },
                      domProps: { value: _vm.fields.billTo },
                      on: {
                        input: [
                          function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.fields, "billTo", $event.target.value)
                          },
                          function($event) {
                            _vm.bill_to_error_msg = ""
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "help is-danger" }, [
                      _vm._v(_vm._s(_vm.bill_to_error_msg))
                    ])
                  ])
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "clearfix" }),
            _vm._v(" "),
            _c("div", { staticClass: "row clearfix" }),
            _vm._v(" "),
            _c("div", { staticClass: "button-demo" }, [
              _c("input", {
                staticClass: "btn btn-primary",
                attrs: {
                  id: "addLocBtn",
                  disabled: _vm.disableButtons.saveButton,
                  type: "submit"
                },
                domProps: { value: _vm.buttonNames.saveButton },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.createRecord()
                  }
                }
              }),
              _vm._v(" "),
              _c("input", {
                staticClass: "btn btn-primary",
                attrs: {
                  id: "addAndContinueLocBtn",
                  disabled: _vm.disableButtons.updateButton,
                  type: "submit"
                },
                domProps: { value: _vm.buttonNames.updateButton },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.updateRecord()
                  }
                }
              }),
              _vm._v(" "),
              _c("input", {
                staticClass: "btn btn-primary",
                attrs: {
                  id: "CancelBenifit",
                  disabled: _vm.disableButtons.cancel,
                  type: "submit"
                },
                domProps: { value: _vm.buttonNames.cancel },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.returnOnListing()
                  }
                }
              })
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Name :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Branch :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Address :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Ship To :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Bill To :")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28f25e44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28f25e44","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Location/Edit.vue
// module id = null
// module chunks = 